import { render, staticRenderFns } from "./ModalLogo.vue?vue&type=template&id=ef09b3e0&"
import script from "./ModalLogo.vue?vue&type=script&lang=js&"
export * from "./ModalLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports